var React = require('react');

function ButtonArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Design","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Homepage","transform":"translate(-355.000000, -797.000000)","fill":"#000000"},React.createElement("g",{"id":"Combined-Shape-2","transform":"translate(355.000000, 797.000000)"},React.createElement("path",{"d":"M29.9743268,-1.11022302e-15 L33.972,3.998 L34,3.99811912 L34,4.026 L34.4724459,4.49811912 L34,4.97 L34,4.99811912 L33.972,4.998 L33.7653392,5.2052259 L33.764,5.204 L29.7656077,9.20334501 L29.0585009,8.49623823 L32.556,4.998 L9.9475983e-14,4.99811912 L9.9475983e-14,3.99811912 L32.558,3.998 L29.26722,0.707106781 L29.9743268,-1.11022302e-15 Z","id":"Combined-Shape"})))));
}

ButtonArrowInline.defaultProps = {"width":"35px","height":"10px","viewBox":"0 0 35 10","version":"1.1"};

module.exports = ButtonArrowInline;

ButtonArrowInline.default = ButtonArrowInline;
